<template>
    <form method="post" class="mt-4 w-full max-w-md mx-auto">
        <slot></slot>
        <div class="mt-4">
            <label class="block text-sm font-medium leading-5 text-brand-gray-700">Your Name</label>
            <input type="text" name="name" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"required="required" />
        </div>
        <div class="mt-4">
            <label class="block text-sm font-medium leading-5 text-brand-gray-700">Your Email Address</label>
            <input type="email" name="emailAddress" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"required="required" />
        </div>
        <div class="mt-4">
            <label class="block text-sm font-medium leading-5 text-brand-gray-700">Best Phone Number to Contact You</label>
            <input type="tel" name="phone" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"required="required" />
        </div>
        <div class="mt-4">
            <label class="block text-sm font-medium leading-5 text-brand-gray-700">School State/Province</label>
            <select @change="loadSchools"
                    v-model="selectedState"
                    name="schoolState"
                    class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                <option value="">State/Province of Nursing School</option>
                <option v-for="province in states" :value="province.abbreviation">
                    {{ province.name }}
                </option>
                {% endfor %}
            </select>
        </div>
        <div class="mt-4">
            <label class="block text-sm font-medium leading-5 text-brand-gray-700">Name of Nursing School<sup>*</sup></label>
            <select name="nursingSchoolId"
                    :disabled="schools.length === 0"
                    class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    required
            >
                <option value="">Name of Nursing School</option>
                <option v-for="school in schools" :value="school.schoolId" :key="school.schoolId">{{school.schoolName}}</option>
            </select>
        </div>
        <fieldset class="border rounded-lg p-2 mt-4">
            <legend class="block text-sm font-medium leading-5 text-brand-gray-700">Spring Graduation</legend>
            <div class="mt-4">
                <label class="block text-sm font-medium leading-5 text-brand-gray-700">Date</label>
                <input type="date" name="springGradDate" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5" placeholder="mm/dd/yyyy"/>
            </div>
            <div class="mt-4">
                <label class="block text-sm font-medium leading-5 text-brand-gray-700">Class Size</label>
                <input type="tel" name="springClassSize" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
            </div>
        </fieldset>
        <fieldset class="border rounded-lg p-2 mt-4">
            <legend class="block text-sm font-medium leading-5 text-brand-gray-700">Fall Graduation</legend>
            <div class="mt-4">
                <label class="block text-sm font-medium leading-5 text-brand-gray-700">Date</label>
                <input type="date" name="fallGradDate" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5" placeholder="mm/dd/yyyy"/>
            </div>
            <div class="mt-4">
                <label class="block text-sm font-medium leading-5 text-brand-gray-700">Class Size</label>
                <input type="tel" name="fallClassSize" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
            </div>
        </fieldset>
        <fieldset class="border rounded-lg p-2 mt-4">
            <legend class="block text-sm font-medium leading-5 text-brand-gray-700">NCLEX reviews at your school are selected by</legend>
            <div class="flex items-center">
                <input type="radio" name="reviewSelectedBy" class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out" value="Administration" />
                <label class="ml-3"><span class="block text-sm leading-5 font-medium text-brand-gray-700">Administration</span></label>
            </div>
            <div class="flex items-center">
                <input type="radio" name="reviewSelectedBy" class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out" value="Faculty" />
                <label class="ml-3"><span class="block text-sm leading-5 font-medium text-brand-gray-700">Faculty</span></label>
            </div>
            <div class="flex items-center">
                <input type="radio" name="reviewSelectedBy" class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out" value="Students" />
                <label class="ml-3"><span class="block text-sm leading-5 font-medium text-brand-gray-700">Students</span></label>
            </div>
        </fieldset>
        <fieldset class="border rounded-lg p-2 mt-4">
            <legend class="block text-sm font-medium leading-5 text-brand-gray-700">Are you currently with another NCLEX review company?</legend>
            <div class="flex items-center">
                <input type="radio" name="currentlyCustomer" value="Yes" class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"/>
                <label class="ml-3"><span class="block text-sm leading-5 font-medium text-brand-gray-700">Yes</span></label>
            </div>
            <div class="flex items-center">
                <input type="radio" name="currentlyCustomer" value="No" class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"/>
                <label class="ml-3"><span class="block text-sm leading-5 font-medium text-brand-gray-700">No</span></label>
            </div>
            <div class="mt-4">
                <label class="block text-sm font-medium leading-5 text-brand-gray-700">If so, What company?</label>
                <input type="text" name="otherCompany" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
            </div>
        </fieldset>
        <div class="mt-4 mb-4">
            <button type="submit" class="btn btn-green">Request Complimentary Account</button>
        </div>
    </form>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "EducatorsRequestAccountForm",

        props: {
            states: {
                required: true,
                type: Array
            }
        },

        data() {
            return {
                schools: [],
                selectedState: ''
            }
        },

        methods: {
            async loadSchools() {
               const { data } = await axios.get(`/ajax/schoolByState/${this.selectedState}`);
               this.schools = data;
            }
        }
    }
</script>

<style scoped>

</style>